// import React from "react";
// import { IMAGES } from "../utils";
// import { Box, Typography, ImageList, ImageListItem, ImageListItemBar } from "@mui/material"

// const itemData = [
//   {
//     img: IMAGES.Profile4,
//     title: "श्री.प्रकाश वसंत सोनवणे",
//     author: "कर्मचारी",
//   },
//   {
//     img: IMAGES.Profile3,
//     title: "श्री.प्रकाश प्रल्हाद सोनवणे",
//     author: "कर्मचारी",
//   },
//   {
//     img: IMAGES.Profile1,
//     title: "श्रीमती संध्या प्रल्हाद पाटील",
//     author: "कर्मचारी",
//   },
//   {
//     img: IMAGES.Profile2,
//     title: "श्रीमती संध्या प्रल्हाद पाटील",
//     author: "कर्मचारी",
//   },
// ];

// const TeamSection = () => {
//   return (
//     <div>
//       <Box>
//         <Typography variant="h6" sx={{ textAlign: "center", m: 3, color: "#002fa7", fontSize: 25, }}>
//           कार्यारत कर्मचारी
//         </Typography>

//         <ImageList cols={4} gap={15} sx={{ padding: 2, mb: 5 }}>
//           {itemData.map((item) => (
//             <ImageListItem key={item.img}>
//               <img
//                 srcSet={`${item.img}?w=248&fit=crop&auto=format&dpr=2 2x`}
//                 src={`${item.img}?w=248&fit=crop&auto=format`}
//                 alt={item.title}
//                 loading="lazy"
//               />
//               <ImageListItemBar
//                 title={item.title}
//                 subtitle={<span> {item.author}</span>}
//                 position="below"
//               />
//             </ImageListItem>
//           ))}
//         </ImageList>
//       </Box>
//     </div>
//   );
// };

// export default TeamSection;


import React from "react";
import { IMAGES } from "../utils";
import {
  Box,
  Typography,
  ImageList,
  ImageListItem,
  useMediaQuery,
  useTheme,
  Container,
} from "@mui/material";

const itemData = [
  {
    img: IMAGES.Profile4,
    title: "श्री.प्रकाश वसंत सोनवणे",
    author: "गृहप्रमुख",
  },
  {
    img: IMAGES.Profile3,
    title: "श्री.अतुल श्रीकांत सहजे",
    author: "वरिष्ठ लिपिक",
  },
  {
    img: IMAGES.Profile2,
    title: "श्रीमती संध्या प्रल्हाद पाटील",
    author: "मुख्य स्वयंपाकी",
  },
  {
    img: IMAGES.Profile1,
    title: "श्रीमती लता विजय जाधव",
    author: "स्वयंपाक मदतनिस",
  },
];

const TeamSection = () => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));
  const isSm = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isMd = useMediaQuery(theme.breakpoints.between("md", "lg"));

  let cols = 4;
  if (isXs) cols = 1;
  else if (isSm) cols = 2;
  else if (isMd) cols = 3;

  return (
    <Box sx={{ p: 3, backgroundColor: "#f4f6fa" }}>
      <Typography
        variant="h6"
        sx={{
          textAlign: "center",
          color: "#002fa7",
          fontSize: 25,
          mb: 3,
        }}
      >
        कार्यारत कर्मचारी
      </Typography>
      <Container>

        <ImageList cols={cols} gap={20} sx={{ justifyContent: "center" }}>
          {itemData.map((item, index) => (
            <ImageListItem
              key={index}
              sx={{
                borderRadius: 2,
                overflow: "hidden",
                boxShadow: 1,
                m: 1,
                transition: "transform 0.3s ease-in-out",
                "&:hover": {
                  transform: "scale(1)",
                },
              }}
            >
              <img
                src={`${item.img}?w=248&fit=crop&auto=format`}
                srcSet={`${item.img}?w=248&fit=crop&auto=format&dpr=2 2x`}
                alt={item.title}
                loading="lazy"
                style={{
                  width: "100%",
                  height: "auto",
                  objectFit: "cover",
                }}
              />
              <Box sx={{ justifyContent: 'center', alignItems: 'center', textAlign: 'center', mt: 2 }}>
                <Typography sx={{ fontSize: 18 }}>{item.title}</Typography>
                <Typography sx={{ fontSize: 16, color: "#444" }}>{item.author}</Typography>
              </Box>

            </ImageListItem>
          ))}
        </ImageList>
      </Container>

    </Box>
  );
};

export default TeamSection;
